var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.28 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6ced1;}.cls-2{fill:#ece7ea;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 48icon-ticket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.55 0 24.82 21 28.55 42 32.28 42 32.28 0 28.55 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.55 0 28.55 42 0 42 0 6.53 4.67 4.67 6.53 0 28.55 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.53 0 6.53 6.53 0 6.53 6.53 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,13.77H4.67a.7.7,0,0,1,0-1.4H23.88a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,25H4.67a.7.7,0,0,1,0-1.4H23.88a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,28.7H16.14a.7.7,0,0,1,0-1.4h7.74a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,7.23H9.33a.7.7,0,0,1,0-1.4H23.88a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,17.5H16.14a.7.7,0,1,1,0-1.4h7.74a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,21.23H16.14a.7.7,0,0,1,0-1.4h7.74a.7.7,0,1,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.67,
    y: 28,
    width: 7.74,
    height: 7.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41,21.23H4.67a.7.7,0,0,1,0-1.4h7.74a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.22,36.17H16.14a.7.7,0,1,1,0-1.4h3.08a.7.7,0,1,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88,32.43H16.14a.7.7,0,0,1,0-1.4h7.74a.7.7,0,0,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41,17.5H4.67a.7.7,0,0,1,0-1.4h7.74a.7.7,0,0,1,0,1.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/icon-ticket.82a6a86934c24b81a3c4781c813e2beb.svg";
export { ForwardRef as ReactComponent };